/**
 * Resolves the base URL for realtime connections.
 *
 * Production builds are served from several hosts (production, staging, firm
 * subdomains), so the origin must come from the browser rather than being
 * hardcoded. Non-production builds run the client on :3000 and the server on
 * :5000, so they keep the explicit localhost target. `REACT_APP_SOCKET_URL`
 * overrides both when a deployment needs to point somewhere else.
 */

const LOCAL_DEV_SOCKET_URL = "http://localhost:5000";

/**
 * Base URL for Socket.IO connections (http/https scheme).
 * @returns {string} Origin to connect to, or "" to mean the current origin.
 */
export const getSocketBaseUrl = () => {
  const configured = process.env.REACT_APP_SOCKET_URL;
  if (configured) return configured;

  if (process.env.NODE_ENV === "production") {
    return typeof window !== "undefined" && window.location
      ? window.location.origin
      : "";
  }

  return LOCAL_DEV_SOCKET_URL;
};

/**
 * Base URL for raw WebSocket connections (ws/wss scheme).
 * @returns {string} Origin to connect to, with the WebSocket scheme applied.
 */
export const getWebSocketBaseUrl = () =>
  getSocketBaseUrl().replace(/^http/, "ws");
